import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Preconnect to Google Fonts to reduce latency
const preconnectOrigins = ['https://fonts.googleapis.com', 'https://fonts.gstatic.com'];
preconnectOrigins.forEach(origin => {
  if (!document.querySelector(`link[rel="preconnect"][href="${origin}"]`)) {
    const link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = origin;
    if (origin.includes('gstatic')) link.crossOrigin = 'anonymous';
    document.head.insertBefore(link, document.head.firstChild);
  }
});
render(<App data-id="element-276" />, document.getElementById('root'));